import React from 'react'
import { KINOTICKETS } from '../constants/paymentProvider'
import getDayKey from '../functions/getDayKey'
import getMomentDateObj from '../functions/getMomentDateObj'
import getTranslationTime from '../functions/getTranslationTime'
import isCurrentPerformance from '../functions/isCurrentPerformance'
import sortPerformancesByDate from '../functions/sortPerformancesByDate'
import ReactScrollLink from '../General/ReactScollLink'
import Translation from '../General/Translation'
import { MULTICINEMA } from '../constants/multiCinemaModes'
import AlternativeLinkButton from '../MovieInformation/AlternativeLinkButton'
import getBluePrices from '../functions/getBluePrices'

const ItemPerformanceShowtimes = ({movieTitle, movieId, keyDay, dateNow, performances, movieIndex, alternativeLinks, theme, noEmptyDaysKeys, isMobile, onClick, translation, stripeAppearance, scrollToPosition, onOpenPerformancePage}) => {
    const cinemas = pmkinoFrontVars.apiData.cinemas.items
    const currentCinemaId = pmkinoFrontVars.cliData.currentCinemaId
    const currentCinema = cinemas[currentCinemaId]
    const { timezone } = translation 
    const filteredPerformances = performances.filter(perf => {
        const perfDate = getMomentDateObj(perf.timeUtc, timezone)

        if(keyDay === getDayKey(perfDate) && isCurrentPerformance(dateNow, perfDate)) {
            return perf
        }
    })

    sortPerformancesByDate(filteredPerformances)

    let sliceInteger = 3
    let additional = ''
    
    if(theme !== 'Arthouse' && (filteredPerformances.length > 3 || (noEmptyDaysKeys.length > 1 && stripeAppearance === 'no_slide'))) {
        additional = <div onClick={onClick} className=" text-medium performance-item-showtime theme-radius-posters-full more"><Translation id="more" trans={translation}>mehr</Translation></div>
        sliceInteger = 2
    }
    
    if(filteredPerformances.length > 2 && isMobile) {
        additional = <div onClick={onClick} className=" text-medium performance-item-showtime theme-radius-posters-full more"><Translation id="more" trans={translation}>mehr</Translation></div>
        sliceInteger = 1
    }
    
    const showtimes = filteredPerformances.slice(0, sliceInteger).map((performance, index) => {
        const { id, timeUtc, deeplinkURL, attributes, cinema } = performance
        const cinemaAlternativeLink = alternativeLinks && alternativeLinks[cinema] ? alternativeLinks[cinema] : null
        const bluePricesClass = getBluePrices(attributes)

        let cinemaDataProvider
        if(currentCinema.scope.type === MULTICINEMA) {
            cinemaDataProvider = cinema
        } else {
            cinemaDataProvider = currentCinema.scope.cinemaDataProvider
        }

        const showTime = getTranslationTime('showtimePerformance', translation, timeUtc)

        if(cinemaAlternativeLink) {
            return <div className={"performance-item-showtime theme-radius-posters-full" + bluePricesClass} key={index}>
                <a className="text-medium" href={cinemaAlternativeLink} rel="noreferrer" target="_blank">
                    {showTime}
                </a>
            </div>
        } else if(cinemaDataProvider && cinemaDataProvider.type === KINOTICKETS) {
            return (
                <div className={"performance-item-showtime theme-radius-posters-full" + bluePricesClass} key={index}>
                    <a className="text-medium" href={deeplinkURL} rel="noreferrer" target="_blank">
                        {showTime}
                    </a>
                </div>
            )
        } else {
            return (
                <div className={"performance-item-showtime theme-radius-posters-full cursor-pointer" + bluePricesClass} key={index}>
                    <ReactScrollLink 
                        to={scrollToPosition + ' performance-iframe'} 
                        smooth={true} 
                        offset={-150}
                        className="text-medium" 
                        onClick={() => onOpenPerformancePage({
                            id: id,
                            timeUtc: timeUtc,
                            url: deeplinkURL,
                            movieIndex: movieIndex,
                            movieId: movieId,
                            movieTitle: movieTitle,
                            cinema: cinema
                        })}
                    >
                        {showTime}
                    </ReactScrollLink>
                </div>
            )
        }      
    })

    return (
        <div className="performance-item-showtimes">
            {showtimes}
            {additional}
        </div>
    )
}

export default ItemPerformanceShowtimes